import { actionTypes } from '../../../controller';
import {
	setLocalStorage,
	removeLocalStorage,
} from '../../../../lib/local-storage-utils';

const {
	SET_CLIENT_LOGIN_CODE_TO_LOCAL_STORAGE,
	CLEAR_CLIENT_LOGIN_CODE,
} = actionTypes;

export function clientLoginCodeMiddleware() {
	return next => action => {
		const { type, clientLoginCode } = action;

		if (type === SET_CLIENT_LOGIN_CODE_TO_LOCAL_STORAGE) {
			setLocalStorage('clientLoginCode', clientLoginCode);
		} else if (type === CLEAR_CLIENT_LOGIN_CODE) {
			removeLocalStorage('clientLoginCode');
		}

		next(action);
	};
}
